import { DivisionLayout } from '../components/layout/DivisionLayout';

const divisionData = {
  divisionName: 'Mill Lining',
  accentColor: '#d42020',
  heroImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/q1mexpww_image.png',
  aboutText: [
    {
      text: '<strong>Catworth</strong> is a specialist manufacturer and processing partner supporting the mining industry\'s mill liner supply chain. As an accredited <strong>Hardox Wearparts® partner for the Gauteng region</strong>, we focus on the precision processing of <strong>Hardox® 500 quenched and tempered wear plate</strong> used in composite mill liner systems.'
    },
    {
      text: 'Our capabilities include the manufacturing of wear inserts for lifter bars and shell plates, as well as the fabrication and supply of key mill internals such as <strong>pulp lifters, ball retainers, and trunnion liners</strong>, supplied rubber-lined and ready for installation. Catworth\'s expertise in wear materials, precision cutting, and fabrication ensures reliable, high-quality components for demanding milling environments.'
    }
  ],
  aboutImage: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/2y18j860_Composite%20mill%20liners.jpeg',
  galleryImages: [
    'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/0rgg7p0e_image.png',
    'https://images.unsplash.com/photo-1597057435443-8a51eeb5538f?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1600683550547-2c38a96fb400?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  capabilities: [
    { title: 'Hardox® 500 Wear Plate Processing', description: 'Precision cutting and processing of quenched and tempered Hardox® 500 wear plate used in composite mill liner systems.' },
    { title: 'Composite Mill Liner Inserts', description: 'Manufacturing of steel wear inserts used in lifter bars and shell plates supplied to mill liner OEMs.' },
    { title: 'Pulp Lifters Manufacturing', description: 'Fabrication and supply of pulp lifters, including units supplied rubber-lined and ready for installation.' },
    { title: 'Ball Retainers', description: 'Manufacture of ball retaining systems designed for durability in high-wear milling environments.' },
    { title: 'Trunnion Liners', description: 'Fabricated trunnion liners supplied with rubber lining for reliable protection of mill entry and discharge points.' },
    { title: 'Heavy Plate Processing & Fabrication', description: 'Advanced cutting, forming, and fabrication of wear-resistant steel components for mining applications.' },
    { title: 'Hardox Wearparts® Certified Partner', description: 'Recognized partner for Hardox® wear solutions in the Gauteng region, ensuring compliance with SSAB material and processing standards.' },
  ],
  partnerLogo: 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/f1fzqxsc_Hardox%20Wearparts%20Logotype.svg',
  partnerLogoUrl: 'https://hardoxwearparts.com/',
};

export const MillLining = () => {
  return <DivisionLayout {...divisionData} />;
};

export default MillLining;
